import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ContentContainer } from '@atlassian/amkt-common';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from '../../constants/proptypes/CommonPropTypes';
import { validateFilters } from '../../utils/filters';
export default class FiltersValidationContainer extends Component {
  render() {
    const validationErrs = validateFilters(this.props.filters);
    return /*#__PURE__*/React.createElement(ContentContainer, {
      baseMessage: "Oops! The filters you provided are invalid.",
      dataError: validationErrs.size > 0,
      dataErrorMessages: validationErrs.map(err => Map({
        message: err
      })).toList(),
      loading: false
    }, this.props.children);
  }
}
_defineProperty(FiltersValidationContainer, "propTypes", {
  children: PropTypes.node,
  filters: CommonPropTypes.filters.isRequired
});